import { createBlockTitleAnchorInfo } from './createBlockTitleAnchorInfo';

import type { ISbComponentType } from 'storyblok-js-client';
import type { BlokAnchors, Locales } from '@monoimin/sb-types';

const BLOKS_FOR_ANCHORS = [
  'text',
  'howTo',
  'listSpoiler',
  'benefits',
  'investmentProgramList',
  'section',
  'licenceWithText',
  'slider',
  'estateSlider',
  'reviewsSlider',
  'factoidList',
  'faq',
  'infographicsSlider',
  'newSection',
];

/**
 * Создание объектов, необходимых для доступа к копонентам тела статьи по якорям.
 * Возвращает объект с ключами (uid блоков), значения которых объекты с ключами href - ссылка якорь, title - заголовок, titleId - id заголовка.
 */
export const createBlokBodyAnchors = <T extends string>(
  body: Array<
    ISbComponentType<T> & {
      title?: string;
    }
  >,
  locale: Locales
) => {
  return body.reduce<BlokAnchors>((acc, item) => {
    const { _uid, title, component } = item;

    const isFaq = component === 'faq';

    // Пропускаем блок faq без title, так как внутри него есть дефолтные title
    const isTitleExists =
      isFaq || (typeof title === 'string' && Boolean(title.length));

    const isBlokForAnchor = Boolean(
      BLOKS_FOR_ANCHORS.find((item) => item === component)
    );

    const passAnchor = isTitleExists && isBlokForAnchor && _uid;

    if (passAnchor) {
      const anchorInfo = createBlockTitleAnchorInfo(item, locale);

      if (anchorInfo) {
        return {
          ...acc,
          [_uid]: anchorInfo,
        };
      }
    }

    return acc;
  }, {});
};

export default createBlokBodyAnchors;
